import Head from 'next/head'

import Layout from '../components/Layout'

export default function Bris(): JSX.Element {
  return (
    <Layout>
      <Head>
        <title>Robert Karasov - Minneapolis Mohel | Why Have A Bris</title>
      </Head>
      <h1 className="mb-6 font-serif text-4xl text-ink sm:text-3xl">
        Why Have A Bris
      </h1>
      <section className="leading-relaxed text-ink">
        <p>
          A medical circumcision is not a bris. Brit Milah is religious ritual
          with deep meaning and religious significance. It includes a
          circumcision, but it is so much more. A bris is safe. I have done
          thousands of circumcisions and the technique for a bris is the same as
          when I perform circumcisions as a pediatrician. A bris is a
          celebration, an affirmation of one’s Jewish identity, and a way to be
          part of a 3500 year old tradition. A Mohel is trained to not only do
          an expert circumcision, but also to make it a meaningful religious
          experience which complies with Jewish law. It is performed in a loving
          environment, usually at home or the synagogue, surrounded by family
          and friends to support the family and comfort the baby. It is a very
          powerful and moving experience for most families.
        </p>
      </section>
    </Layout>
  )
}
